import React from 'react';
import { css } from 'react-emotion';
import PropTypes from 'prop-types';

type Params = {
  value: number,
  withStatus: ?boolean
}

const SmallProgress = ({ value, withStatus }: Params) => (
  <React.Fragment>
    <div className={progress}>
      <div className={progressInner} style={{width: `${value}%`}}></div>
    </div>
    {withStatus && <span className={text}>{value}%</span>}
  </React.Fragment>
);

SmallProgress.propTypes = {
  value: PropTypes.number.isRequired,
  withStatus: PropTypes.bool.isRequired,
};

SmallProgress.defaultProps = {
  withStatus: true,
};

export default SmallProgress;

const progress = css`
  background-color: rgb(168, 168, 168);
  width: 40px;
  border-radius: 5px;
  overflow: hidden;
`;

const progressInner = css`
  height: 10px;
  width: 40%;
  background-color: rgb(216, 109, 135);
`;

const text = css`
  margin-left: 4px;
  font-size: 14px;
  font-weight: 600;
`;


// WEBPACK FOOTER //
// ./src/components/ui/SmallProgress.jsx